import React, { useState } from 'react'
import { MbscCalendarEvent, MbscRecurrenceRule, Popup } from '@mobiscroll/react-latest'
import { MoonLoader } from 'react-spinners'
import classNames from 'classnames'

interface ITimelineEventPopupProps {
  eventInfo: MbscCalendarEvent | undefined
  isTooltipOpen: boolean
  tooltipAnchor: HTMLElement | undefined
  loading: boolean
  handleMouseEnter: () => void
  handleMouseLeave: () => void
  handleTooltipClose: () => void
}

const initialSchedule: MbscRecurrenceRule = {
  repeat: 'weekly',
  weekDays: ''
}

const ViewDaysOfWeek = ({ days, id }: { days: string[]; id: string }) => {
  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

  const daysOfWeekShortcut = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

  return (
    <div className='flex'>
      {daysOfWeek.map((it, index) => {
        const classes = classNames('day-of-week p1 mt1', {
          'bg-light-grey2 font-grey2': !days.includes(it),
          'bg-green font-white': days.includes(it)
        })

        return (
          <div className={classes} key={`${it}-${id}`}>
            {daysOfWeekShortcut[index]}
          </div>
        )
      })}
    </div>
  )
}

const convertWeekdayAbbreviations = (input: string): string[] => {
  const weekdayMap: Record<string, string> = {
    MO: 'Monday',
    TU: 'Tuesday',
    WE: 'Wednesday',
    TH: 'Thursday',
    FR: 'Friday',
    SA: 'Saturday',
    SU: 'Sunday'
  }

  if (!input) {
    return []
  }
  return input.split(',').map(day => {
    const mapped = weekdayMap[day.trim()]
    if (!mapped) {
      console.warn(`Unknown weekday abbreviation: ${day}`)
      return day
    }
    return mapped
  })
}

const isMbscRecurrenceRule = (obj: any): obj is MbscRecurrenceRule => {
  return obj !== null && typeof obj === 'object' && 'repeat' in obj && typeof obj.repeat === 'string'
}

const TimelineSchedulePopup = ({
  eventInfo,
  isTooltipOpen,
  tooltipAnchor,
  loading,
  handleMouseEnter,
  handleMouseLeave,
  handleTooltipClose
}: ITimelineEventPopupProps) => {
  if (eventInfo === undefined || !isTooltipOpen) {
    return null
  }
  const recurring = isMbscRecurrenceRule(eventInfo.recurring) ? eventInfo.recurring : initialSchedule
  const [dayStrings, setDayStrings] = useState<MbscRecurrenceRule>(recurring)

  const { color } = eventInfo

  return (
    <span onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Popup
        anchor={tooltipAnchor}
        contentPadding={false}
        cssClass='tmln-schedule-popup'
        display='anchored'
        isOpen={isTooltipOpen}
        scrollLock={false}
        showArrow={false}
        showOverlay={false}
        touchUi={false}
        width={550}
        onClose={handleTooltipClose}
      >
        <div className='tmln-popup-trip-link'>
          <div className='mds-tooltip'>
            <div className='mds-tooltip-header p2 flex flex-row justify-between' style={{ backgroundColor: color }}>
              <div className='flex-column'>
                <div className='font-black weight-600 font-gray'>Daily Shift</div>
              </div>
            </div>
            <div className='mbsc-padding tmln-popup-body'>
              {loading === false ? (
                <div className='flex flex-column col-12'>
                  <div className='flex flex-row col-12'>
                    <div className='flex flex-row col-6 pr1'>
                      <div className='weight-600 flex justify-start col-6 font-gray'>Shift Start: </div>
                      <div className='flex justify-start col-6 font-gray'>
                        {eventInfo && eventInfo.original ? eventInfo.original.start : 'Not Available'}
                      </div>
                    </div>
                    <div className='flex flex-row col-6 pl1'>
                      <div className='weight-600 flex justify-start col-6 font-gray'>Shift End: </div>
                      <div className='flex justify-start col-6 font-gray'>
                        {eventInfo && eventInfo.original ? eventInfo.original.end : 'Not Available'}
                      </div>
                    </div>
                  </div>
                  <div className='flex flex-row col-12 pt2'>
                    <div className='flex flex-row pr2 items-center'>
                      <div className='weight-600 flex justify-start col-6 font-gray'>Days: </div>
                    </div>
                    <div className='flex flex-row items-center'>
                      <ViewDaysOfWeek
                        days={convertWeekdayAbbreviations(dayStrings && dayStrings.weekDays ? dayStrings.weekDays : '')}
                        id={`${eventInfo.id}`}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className='tmln-popup-loading'>
                  <MoonLoader sizeUnit={'px'} size={20} color={'#405264'} loading={true} />
                </div>
              )}
            </div>
          </div>
        </div>
      </Popup>
    </span>
  )
}

export default TimelineSchedulePopup



// WEBPACK FOOTER //
// ./src/components/trips/timeline-view/TimelineSchedulePopup.tsx